import React from 'react';
import { CheckIcon, StarIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { plans } from '../data/content';
export function PricingSection() {
  return <section id="pricing" className="w-full scroll-mt-6 bg-ink px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="planes-title" data-id="element-183" data-mp="1ehgtokrkry6z">
      <div className="mx-auto max-w-5xl" data-id="element-184" data-mp="1nakc77h2v18h">
        <CountdownTimer heading="⏰ Precio de lanzamiento — cierra en:" note="⚠️ Después sube $8.000 ARS. No vuelve." data-id="element-185" data-mp="1n9r1jvezzrl2" />

        <div className="mt-8 rounded-3xl border border-line bg-surface p-6" data-id="element-186" data-mp="1x8qdbmv283ca">
          <p className="text-sm font-bold text-white" data-id="element-187" data-mp="1x9i0c9alcsqy">
            📊 Cupos al precio de lanzamiento — Quedan pocos
          </p>
          <div className="mt-4 h-3 w-full overflow-hidden rounded-full bg-ink" role="progressbar" aria-valuenow={68} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos al precio de lanzamiento tomados" data-id="element-188" data-mp="2uyupxur694p">
            <div className="h-full w-[68%] rounded-full bg-ember" data-id="element-189" data-mp="1hpy97xpcd6pn" />
          </div>
          <p className="mt-3 text-xs font-medium text-neutral-400" data-id="element-190" data-mp="1hnvampa4i59b">
            68% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>

        <h2 id="planes-title" className="mt-14 text-center text-3xl font-extrabold tracking-tight text-white sm:text-5xl" data-id="element-191" data-mp="17sto8178fhaf">
          Elegí tu Megakit
        </h2>

        <div className="mt-10 grid gap-5 lg:grid-cols-2" data-id="element-192" data-mp="20hhb217mqeq3">
          {plans.map(plan => <article key={plan.id} className={`relative flex flex-col rounded-3xl border p-6 sm:p-8 ${plan.featured ? 'border-gold bg-surface shadow-gold' : 'border-line bg-surface'}`} data-id="element-193" data-mp="1vgl5lj7mqkik">
              {plan.featured ? <span className="absolute -top-3 left-6 inline-flex items-center gap-1 rounded-full bg-gold px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.15em] text-ink" data-id="element-194" data-mp="fzb0os2zih0p">
                  <StarIcon className="h-3 w-3 fill-ink" aria-hidden="true" data-id="element-195" data-mp="mfjn3y66yvui" />
                  Más elegido
                </span> : null}

              <h3 className="text-xl font-extrabold leading-tight tracking-tight text-white sm:text-2xl" data-id="element-196" data-mp="cievvjxhoa6u">
                🏋️ {plan.name}
              </h3>
              <p className="mt-3 text-sm font-bold text-gold" data-id="element-197" data-mp="3uv3706kz31ww">{plan.includes}</p>
              <p className="mt-2 text-sm text-neutral-400" data-id="element-198" data-mp="3is5dt6asosk">
                <span className="font-semibold text-neutral-300" data-id="element-199" data-mp="3kyqh7jsjt87f">
                  Ideal para:
                </span>{' '}
                {plan.idealFor}
              </p>

              <div className="mt-6 flex flex-wrap items-baseline gap-3 border-t border-line pt-6" data-id="element-200" data-mp="3pvgyubk04buy">
                <span className="text-lg text-neutral-600 line-through" data-id="element-201" data-mp="3bzwmjyys2rwi">
                  {plan.oldPrice}
                </span>
                <span className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl" data-id="element-202" data-mp="2xatq1iqacsfx">
                  {plan.price}
                </span>
              </div>

              <div className="mt-6 flex-1" data-id="element-203" data-mp="2secysfnshxym" />
              <CtaButton href="#pricing" variant={plan.featured ? 'primary' : 'outline'} data-id="element-204" data-mp="36c1ihk64ez23">
                {plan.cta}
              </CtaButton>
              <p className="mt-4 flex items-center justify-center gap-1.5 text-xs text-neutral-500" data-id="element-205" data-mp="3g9friyppslkd">
                <CheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-206" data-mp="3bbnx9y1lknd0" />
                Garantía 7 días · Acceso en 5 minutos
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}